document.addEventListener("DOMContentLoaded", function() {
    // Video mask functionality
    const videoMasks = document.querySelectorAll('.col-video-mask');
    videoMasks.forEach(mask => {
        mask.addEventListener('click', function() {
            this.classList.add('hidden');
            const mediaElement = this.nextElementSibling;
            
            if (mediaElement.tagName === 'IFRAME') {
                const currentSrc = mediaElement.src;
                if (!currentSrc.includes('autoplay=1')) {
                    mediaElement.src = currentSrc.includes('?') 
                        ? currentSrc + '&autoplay=1&mute=1' 
                        : currentSrc + '?autoplay=1&mute=1';
                }
            } else if (mediaElement.tagName === 'VIDEO') {
                mediaElement.play();
            }
        });
    });
}); 